import React, {useMemo} from 'react';
import {useProjectFormMailReportsByEmployeeRangeQuery} from 'api';
import {useParams} from 'react-router-dom';
import Table from '../Table';
import employeeRangeOptions from 'helpers/employeeRangeOptions';

export default () => {
  const {projectId} = useParams<{projectId: string}>();
  const {data: {projectFormMailReportsByEmployeeRange = []} = {}} =
    useProjectFormMailReportsByEmployeeRangeQuery({
      variables: {uuid: projectId},
      fetchPolicy: 'cache-and-network',
    });

  const data: any = useMemo(
    () =>
      projectFormMailReportsByEmployeeRange.map((report) => {
        return {
          name: employeeRangeOptions.find(
            (employeeRangeOption) =>
              employeeRangeOption.value === report.employeeRange,
          ).label,
          mailCount: report.mailCount,
          clickCount: report.clickCount,
          clickRate: report.clickRate,
          replyCount: report.replyCount,
          replyRate: report.replyRate,
          appointCount: report.appointCount,
          appointRate: report.appointRate,
        };
      }),
    [projectFormMailReportsByEmployeeRange],
  );

  return <Table data={data} />;
};
